import React from 'react';
import about from '../img/about.jpg';
import aboutFloating2 from '../img/about02.jpg';
import mariyan from '../img/mariyan.jpeg';
import aboutFloating3 from '../img/about03.jpg';
import ImageWrapper from '../components/ImageWrapper';
import Button from '../components/Button';
import cook from '../img/cook.jpg';
import ContactForm from '../components/ContactForm';
import '../index.css';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect } from 'react';
import Testimonials from '../components/Testimonials';

function About() {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        watchDrag: true,
        breakpoints: {
            '(min-width: 1100px)': { watchDrag: false },
        },
    });

    useEffect(() => {
        if (emblaApi) {
            console.log(emblaApi.slideNodes()); // Access API
        }
    }, [emblaApi]);
    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);
    return (
        <>
            <div className="w-full flex flex-col-reverse lg:flex-row items-center justify-end">
                <div className="bg-secondary lg:bg-opacity-75 flex justify-center lg:justify-end lg:absolute w-full left-0 p-16 lg:p-20 lg:pl-40 lg:w-1/2">
                    <div className="flex flex-col items-center text-center lg:text-start lg:items-start">
                        <h1 className="text-5xl">
                            Let's Create Your Perfect Day!
                        </h1>
                        <p className="text-2xl my-4">
                            Custom event planning and catering services designed
                            to fit your unique needs
                        </p>
                        <div className="flex flex-col lg:flex-row items-center gap-4">
                            <Button href="/contact">Get In Touch</Button>
                            <a
                                href="/services"
                                className="animated_link text-brand">
                                Our Services
                            </a>
                        </div>
                    </div>
                </div>
                <ImageWrapper
                    src={about}
                    className="w-full lg:w-3/4"
                    alt="About"
                />
            </div>
            <div className="page__width relative flex my-40 flex-col items-center">
                <ImageWrapper
                    src={mariyan}
                    className="absolute hidden lg:block -z-[98] w-64 rotate-[17deg] -top-16 -right-32"
                />
                <ImageWrapper
                    src={aboutFloating2}
                    className="absolute hidden lg:block -z-[98] w-52 rotate-[-17deg] -bottom-16 -left-32"
                />
                <ImageWrapper
                    src={aboutFloating3}
                    className="absolute hidden lg:block -z-[98] w-40 rotate-[7deg] -top-32 left-0"
                />
                <div className="absolute -z-[99] w-64 bg-secondary h-80 -top-20 lg:top-0 right-0" />
                <h2 className="w-4/5 text-center text-3xl lg:text-5xl">
                    After two decades of delivering memorable experiences and
                    high-profile events across Europe, the Middle East, and the
                    UK, I've embarked on an exciting new chapter called Smooth
                    Affairs.
                </h2>
                <Button
                    href="/contact"
                    additionalStyles="mt-6">
                    Get In Touch
                </Button>
            </div>
            <div className="page__width relative mt-40 flex flex-col lg:flex-row items-start justify-between">
                <div className="w-full lg:w-1/2 flex flex-col">
                    <h5 className="uppercase text-brand text-center lg:text-start text-sm">
                        Catering
                    </h5>
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                        We are here to create an event that leaves you
                        speechless and turns you into a storyteller.
                    </h2>
                    <ImageWrapper
                        src={cook}
                        className="w-3/4 my-8 lg:mt-4"
                    />
                </div>
                <div className="w-full lg:w-1/2 flex flex-col gap-4">
                    <p className="w-full text-text text-base lg:text-lg text-center lg:text-start">
                        Throughout my journey, I’ve had the privilege of meeting
                        and collaborating with some of the industry's finest
                        professionals, forging connections that span continents
                        and cultures.
                    </p>
                    <p className="w-full text-text text-base lg:text-lg text-center lg:text-start">
                        The trust and shared vision of the incredible clients
                        I’ve had the honour to work with have turned my job into
                        a true passion, making every moment truly worthwhile. My
                        team and I are dedicated to curating exceptional events
                        that leave lasting impressions, ensuring that every
                        detail reflects the highest standards of luxury and
                        elegance.
                    </p>
                    <div className="flex items-start justify-center lg:justify-start gap-16">
                        <div className="flex flex-col items-center">
                            <h3 className="text-4xl lg:text-7xl text-brand">
                                140
                            </h3>
                            <p className="text-text text-base lg:text-lg text-center">
                                Satisfied Clients
                            </p>
                        </div>
                        <div className="flex flex-col items-center">
                            <h3 className="text-4xl lg:text-7xl text-brand">
                                38
                            </h3>
                            <p className="text-text text-base lg:text-lg text-center">
                                Events Hosted
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative bg-secondary py-16 mt-40 flex flex-col items-center justify-between">
                <Testimonials />
            </div>
            <div className="page__width flex flex-col lg:flex-row gap-8 lg:gap-0 items-start justify-between my-40">
                <div className="w-full lg:w-2/5 flex flex-col items-start gap-2 lg:gap-4">
                    <h3 className="text-xl lg:text-2xl text-white">
                        Contact details
                    </h3>
                    <p className="w-full text-text text-base lg:text-lg ">
                        25 Thurso House, Randolph Gardens, NW65EL <br />
                        London, United Kingdom
                    </p>
                    <a
                        href="mailto:mariyan.alekov@smoothaffairs.co.uk"
                        target="_blank"
                        rel="noreferrer"
                        className="w-full text-brand underline text-base lg:text-lg ">
                        mariyan.alekov@smoothaffairs.co.uk
                    </a>
                    <p className="w-full text-text text-base lg:text-lg ">
                        +44 748 022 99 43
                    </p>
                </div>
                <div className="w-full lg:w-3/5 flex flex-col items-start">
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                        Contact Us
                    </h2>
                    <ContactForm />
                </div>
            </div>
        </>
    );
}

export default About;
